const MULTILIKES_OPTIMISTIC_DISABLE_MS = 500;

function disableTemporarily(element, duration = MULTILIKES_OPTIMISTIC_DISABLE_MS) {
  if (!element) return;
  element.disabled = true;
  if (element._multilikesDisableTimer) {
    clearTimeout(element._multilikesDisableTimer);
  }
  element._multilikesDisableTimer = setTimeout(() => {
    element.disabled = false;
    element._multilikesDisableTimer = null;
  }, duration);
}

function parseFavoriteCountValue(value) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : Math.max(0, parsed);
}

function adjustFavoriteCountValue(currentCount, wasFavorited, isFavorited) {
  const parsed = parseFavoriteCountValue(currentCount);
  if (parsed === null || wasFavorited === isFavorited) {
    return parsed;
  }
  return isFavorited ? parsed + 1 : Math.max(0, parsed - 1);
}

// 商品お気に入りボタン
class CustomProductWishlistButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId || '';
    this.variantId = button.dataset.variantId || '';
    this.customerId = window.multilikesProductConfig?.customerId || button.dataset.customerId || null;
    this.isInWishlist = button.dataset.isInWishlist === 'true';
    this.defaultUrl = window.multilikesProductConfig.defaultUrl;
    this.texts = window.multilikesProductConfig?.texts || {};
    this.favoriteCount = parseFavoriteCountValue(button.dataset.favoriteCount);
    this.requestSeq = 0;
    this.pendingRequestCount = 0;
    this.finalSyncTimer = null;

    if (this.customerId) {
      this.button.addEventListener('click', () => this.toggleWishlist());
    } else {
      this.button.addEventListener('click', () => this.redirectToLogin());
      // this.button.textContent = this.texts.addToFavorites || 'お気に入りに追加';
      // if(this.button.dataset.favoriteCount) {
      //   this.button.textContent += ` (${this.button.dataset.favoriteCount})`;
      // }
    }
  }

  updateButtonState(isInWishlist, favoriteCount) {
    if (typeof isInWishlist === 'boolean') {
      this.isInWishlist = isInWishlist;
    }

    this.button.dataset.isInWishlist = this.isInWishlist.toString();
    this.button.classList.toggle('is-active', this.isInWishlist);

    if (favoriteCount !== undefined && favoriteCount !== null) {
      this.favoriteCount = parseFavoriteCountValue(favoriteCount) ?? 0;
    }

    // let buttonText = this.isInWishlist
    //   ? (this.texts.removeFavorites || 'お気に入りから削除')
    //   : (this.texts.addToFavorites || 'お気に入りに追加');

    // this.button.textContent = buttonText;

    // Button Wishlist Count
    const wishlistCountTextList = document.querySelectorAll(`[data-multilikes-product-count][data-product-id="${this.productId}"]`);
    if(wishlistCountTextList.length > 0 && this.favoriteCount !== null) {
      wishlistCountTextList.forEach(wishlistCountText => {
        const template =
          this.texts.favoriteCount || wishlistCountText.textContent || 'お気に入り数：[[amount]]件';
        wishlistCountText.textContent = template.replace('[[amount]]', String(this.favoriteCount));
        wishlistCountText.classList.remove('is-loading');
      });
    }
  }

  resolveFavoriteCount(data) {
    if (!data) {
      return null;
    }

    const favoriteCount = data.favoriteCount;
    if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
      return favoriteCount;
    }

    const updatedCount = data.updatedCount;
    if (typeof updatedCount === 'number' && !Number.isNaN(updatedCount)) {
      return updatedCount;
    }

    return null;
  }

  nextRequestSeq() {
    this.requestSeq += 1;
    return this.requestSeq;
  }

  isLatestRequest(seq, productId = this.productId, variantId = this.variantId) {
    return seq === this.requestSeq &&
      productId === this.productId &&
      variantId === this.variantId;
  }

  invalidatePendingResponses() {
    this.requestSeq += 1;
  }

  scheduleFinalSync() {
    if (this.finalSyncTimer) {
      clearTimeout(this.finalSyncTimer);
    }
    this.finalSyncTimer = setTimeout(() => {
      this.finalSyncTimer = null;
      if (this.pendingRequestCount === 0 && this.customerId) {
        CustomProductWishlistButton.updateButtonStatus(this, { includeFavoriteCount: true });
      }
    }, 0);
  }

  async toggleWishlist() {
    const previousState = this.isInWishlist;
    const previousCount = this.favoriteCount;
    const nextState = !previousState;
    const action = nextState ? 'add' : 'remove';
    const requestProductId = this.productId;
    const requestVariantId = this.variantId;
    const seq = this.nextRequestSeq();
    this.pendingRequestCount += 1;
    this.updateButtonState(
      nextState,
      adjustFavoriteCountValue(previousCount, previousState, nextState)
    );
    disableTemporarily(this.button);

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'product_id': requestProductId,
          'variant_id': requestVariantId,
          'target_type': 'product',
          'action': action
        })
      });

      const data = await response.json();

      if (!this.isLatestRequest(seq, requestProductId, requestVariantId)) {
        if (!response.ok) {
          console.error('Stale wishlist update failed:', data);
        }
        return;
      }

      if (response.ok) {
        const payload = data?.data || {};

        const favoriteCount = this.resolveFavoriteCount(payload);
        const resolvedState = typeof payload.isInWishlist === 'boolean'
          ? payload.isInWishlist
          : nextState;
        this.updateButtonState(resolvedState, favoriteCount);
      } else {
        throw new Error(data?.error || 'Failed to update wishlist');
      }
    } catch (error) {
      if (this.isLatestRequest(seq, requestProductId, requestVariantId)) {
        this.updateButtonState(previousState, previousCount);
        alert(this.texts.error || 'お気に入りの更新に失敗しました');
      } else {
        console.error('Stale wishlist update failed:', error);
      }
    } finally {
      this.pendingRequestCount = Math.max(0, this.pendingRequestCount - 1);
      if (this.pendingRequestCount === 0) {
        this.scheduleFinalSync();
      }
    }
  }

  redirectToLogin() {
    window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
  }

  /**
   * 静的メソッド：商品お気に入りボタンの初期化
   * @param {HTMLElement} button - 商品お気に入りボタン要素
   * @returns {CustomProductWishlistButton|null} - 作成されたインスタンス
   */
  static async init(button) {
    if (!button) {
      console.error('Button element is required');
      return null;
    }
    
    const variantId = button.dataset.variantId;
    
    if (!variantId) {
      console.error('Variant ID not found in button');
      return null;
    }

    // 既に初期化済みの場合はスキップ
    if (button.dataset.initialized === 'true') {
      return button._wishlistButtonInstance;
    }

    button.dataset.initialized = 'true';
    
    // 新しいインスタンスを作成
    const instance = new CustomProductWishlistButton(button);
    button._wishlistButtonInstance = instance;
    
    return instance;
  }

  /**
   * 静的メソッド：すべての商品お気に入りボタンを初期化
   */
  static async initAllButtons() {
    const wishlistButtons = document.querySelectorAll('[data-custom-multilikes-product-button]');
    console.log("wishlistButtons",wishlistButtons);
    const initPromises = Array.from(wishlistButtons).map(button => 
      CustomProductWishlistButton.init(button)
    );
    await Promise.all(initPromises);

    
    wishlistButtons.forEach(button => {
      const variantId = button.dataset.variantId;
      const productId = button.dataset.productId;
      if(variantId && productId) {
        const sectionFormNameElement = document.querySelector('[name="id"][value="' + variantId + '"]');
        if(sectionFormNameElement) {
          const sectionFormElement = sectionFormNameElement.closest('form');
  
          if(sectionFormElement) {
            CustomProductWishlistButton.watchVariantChanges(sectionFormElement, button);
            return;
          }
        }
      }

      const instance = button._wishlistButtonInstance;
      if (instance?.customerId) {
        CustomProductWishlistButton.updateButtonStatus(instance, { includeFavoriteCount: true });
      }
    });
  }

  /**
   * 静的メソッド：商品フォームのバリアント変更を監視
   */
  static watchVariantChanges(sectionFormElement, button) {
    const productForm =sectionFormElement;

    if (productForm) {
      const variantSelect = productForm.querySelector('[name="id"]');
      if (variantSelect) {
        let isInitialUpdate = true;
        const handleVariantChange = async () => {
          try {
            await CustomProductWishlistButton.updateButtonData(button, productForm, {
              includeFavoriteCount: isInitialUpdate,
            });
            isInitialUpdate = false;
          } catch (error) {
            console.error('Error updating wishlist button data:', error);
          }
        };

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'value') {
              handleVariantChange();
            }
          });
        });

        observer.observe(variantSelect, {
          attributes: true,
          attributeFilter: ['value']
        });
        
        // 初期状態も更新
        handleVariantChange();
      }
    }
  }

  /**
   * 静的メソッド：ボタンのdata属性を更新
   */
  static async updateButtonData(button, productForm, options = {}) {
    try {
      const productIdSelect = productForm.querySelector('[name="product-id"]');
      const variantIdSelect = productForm.querySelector('[name="id"]');
      
      if (productIdSelect && variantIdSelect) {
        const newProductId = productIdSelect.value;
        const newVariantId = variantIdSelect.value;
        
        // data属性を更新
        button.dataset.productId = newProductId;
        button.dataset.variantId = newVariantId;
        
        // インスタンスのプロパティも更新
        if (button._wishlistButtonInstance) {
          button._wishlistButtonInstance.invalidatePendingResponses();
          button._wishlistButtonInstance.productId = newProductId;
          button._wishlistButtonInstance.variantId = newVariantId;

          // 新しいvariantIdのお気に入りステータスを確認してボタンステータスを更新
          await CustomProductWishlistButton.updateButtonStatus(button._wishlistButtonInstance, options);
        }
      }
    } catch (error) {
      console.error('Error updating button data:', error);
    }
  }

  /**
   * 静的メソッド：ボタンのお気に入りステータスを更新
   */
  static async updateButtonStatus(instance, options = {}) {
    const requestProductId = instance.productId;
    const requestVariantId = instance.variantId;
    const seq = instance.nextRequestSeq();

    try {
      // ローディング状態を設定
      instance.button.classList.add('is-loading');

      const params = new URLSearchParams({
        'customer_id': instance.customerId,
        'target_type': 'product',
        'product_id': instance.productId,
        'variant_id': instance.variantId,
      });
      if (options.includeFavoriteCount === false) {
        params.set('skip_favorite_count', 'true');
      }

      const response = await fetch(`${instance.defaultUrl}?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();

        if (!instance.isLatestRequest(seq, requestProductId, requestVariantId)) {
          return;
        }

        if (data.data && data.data.isInWishlist !== undefined) {
          const favoriteCount = instance.resolveFavoriteCount(data.data);
          instance.updateButtonState(data.data.isInWishlist, favoriteCount);
        }
      } else {
        console.error('Failed to check wishlist status for variant:', instance.variantId);
      }
    } catch (error) {
      console.error('Error checking wishlist status for variant:', error);
    } finally {
      // ローディング状態を解除
      instance.button.classList.remove('is-loading');
    }
  }
}

// ブランドお気に入りボタン
class CustomProductBrandWishlistButton {
  constructor(button) {
    this.button = button;
    this.vendor = this.parseVendor(button.dataset.vendor);
    this.customerId = window.multilikesProductConfig?.customerId || button.dataset.customerId || null;
    this.defaultUrl = window.multilikesProductConfig.defaultUrl;
    this.texts = window.multilikesProductConfig?.texts || {};
    this.metaobjectId = null;
    this.isInWishlist = false;
    this.favoriteCount = 0;
    this.showFavoritesCount = button.dataset.showFavoritesCount === 'true';
    this.favoriteCountText = button.dataset.favoriteCountText || '([[amount]])';
    this.requestSeq = 0;
    this.pendingRequestCount = 0;
    this.finalSyncTimer = null;
  }

  parseVendor(rawVendor) {
    if (!rawVendor) return '';
    try {
      const parsed = JSON.parse(rawVendor);
      if (typeof parsed === 'string') {
        return parsed;
      }
    } catch (_) {
      // noop
    }
    return rawVendor;
  }

  updateButtonState(isInWishlist, favoriteCount) {
    if (typeof isInWishlist === 'boolean') {
      this.isInWishlist = isInWishlist;
    }

    if (favoriteCount !== undefined && favoriteCount !== null) {
      this.favoriteCount = parseFavoriteCountValue(favoriteCount) ?? (this.showFavoritesCount ? 0 : this.favoriteCount);
    } else if (this.showFavoritesCount) {
      this.favoriteCount = 0;
    }

    this.button.dataset.isInWishlist = this.isInWishlist.toString();
    if (this.metaobjectId) {
      this.button.dataset.metaobjectId = this.metaobjectId;
    }
    this.button.classList.toggle('is-active', this.isInWishlist);

    // const buttonText = this.isInWishlist
    //   ? (this.texts.removeFromBrandFavoritesText || 'お気に入りから削除')
    //   : (this.texts.addToBrandFavoritesText || 'お気に入りに追加');
    if (this.showFavoritesCount) {
      const count = Number.isFinite(this.favoriteCount) ? this.favoriteCount : 0;
      const template = this.favoriteCountText || '([[amount]])';
      // this.button.textContent = `${buttonText} ${template.replace('[[amount]]', String(count))}`;
    } else {
      // this.button.textContent = buttonText;
    }

    this.button.removeAttribute('hidden');
    if(this.button.closest('.c-product-wishlist-brand-btn__wrapper[hidden]')) {
      this.button.closest('.c-product-wishlist-brand-btn__wrapper').removeAttribute('hidden');
    }
  }

  resolveFavoriteCount(data) {
    if (!data) {
      return null;
    }
    const favoriteCount = data.favoriteCount;
    if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
      return favoriteCount;
    }
    const updatedCount = data.updatedCount;
    if (typeof updatedCount === 'number' && !Number.isNaN(updatedCount)) {
      return updatedCount;
    }
    return null;
  }

  nextRequestSeq() {
    this.requestSeq += 1;
    return this.requestSeq;
  }

  isLatestRequest(seq, metaobjectId = this.metaobjectId) {
    return seq === this.requestSeq && metaobjectId === this.metaobjectId;
  }

  scheduleFinalSync() {
    if (this.finalSyncTimer) {
      clearTimeout(this.finalSyncTimer);
    }
    this.finalSyncTimer = setTimeout(() => {
      this.finalSyncTimer = null;
      if (this.pendingRequestCount === 0 && this.metaobjectId) {
        this.fetchBrandMetaobject({ silent: true });
      }
    }, 0);
  }

  async toggleWishlist() {
    if (!this.metaobjectId) {
      return;
    }
    const previousState = this.isInWishlist;
    const previousCount = this.favoriteCount;
    const nextState = !previousState;
    const action = nextState ? 'add' : 'remove';
    const requestMetaobjectId = this.metaobjectId;
    const seq = this.nextRequestSeq();
    this.pendingRequestCount += 1;
    this.updateButtonState(
      nextState,
      adjustFavoriteCountValue(previousCount, previousState, nextState)
    );
    disableTemporarily(this.button);

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'metaobject_type': 'multilikes_brand',
          'metaobject_id': requestMetaobjectId,
          'target_type': 'metaobject',
          'action': action
        })
      });

      const data = await response.json();

      if (!this.isLatestRequest(seq, requestMetaobjectId)) {
        if (!response.ok) {
          console.error('Stale brand wishlist update failed:', data);
        }
        return;
      }

      if (response.ok) {
        const payload = data?.data || {};

        const favoriteCount = this.resolveFavoriteCount(payload);
        const isInWishlist = typeof payload.isInWishlist === 'boolean'
          ? payload.isInWishlist
          : nextState;
        this.updateButtonState(isInWishlist, favoriteCount);
      } else {
        throw new Error(data?.error || 'Failed to update brand wishlist');
      }
    } catch (error) {
      if (this.isLatestRequest(seq, requestMetaobjectId)) {
        this.updateButtonState(previousState, previousCount);
        alert(this.texts.error || 'お気に入りの更新に失敗しました');
      } else {
        console.error('Stale brand wishlist update failed:', error);
      }
    } finally {
      this.pendingRequestCount = Math.max(0, this.pendingRequestCount - 1);
      if (this.pendingRequestCount === 0) {
        this.scheduleFinalSync();
      }
    }
  }

  redirectToLogin() {
    window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
  }

  async fetchBrandMetaobject(options = {}) {
    if (!this.vendor) {
      this.disableButton('ブランド情報がありません');
      return;
    }

    const seq = this.nextRequestSeq();
    const requestMetaobjectId = this.metaobjectId;

    try {
      if (!options.silent && !this.metaobjectId) {
        this.button.disabled = true;
      }
      this.button.classList.add('is-loading');

      const params = new URLSearchParams({
        'target_type': 'get_product_brand',
        'vendor': this.vendor,
        'limit': '5',
      });

      if (this.customerId) {
        params.set('customer_id', this.customerId);
      }

      const response = await fetch(`${this.defaultUrl}?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        if (!this.isLatestRequest(seq, requestMetaobjectId)) {
          return;
        }
        console.error('Failed to fetch brand metaobjects:', response.status);
        if (!options.silent) {
          this.disableButton(this.texts.error || 'ブランド情報の取得に失敗しました');
        }
        return;
      }

      const data = await response.json();

      if (!this.isLatestRequest(seq, requestMetaobjectId)) {
        return;
      }

      const payload = data?.data || {};

      const primaryBrand = payload.primaryBrand || (Array.isArray(payload.brands) ? payload.brands[0] : null);

      if (!primaryBrand?.id) {
        this.disableButton(this.texts.empty || 'ブランドが見つかりません');
        return;
      }

      this.metaobjectId = primaryBrand.id;
      const favoriteCount = this.resolveFavoriteCount(primaryBrand);
      this.updateButtonState(Boolean(primaryBrand.isInWishlist), favoriteCount);
    } catch (error) {
      console.error('Error fetching brand metaobjects:', error);
      if (!options.silent) {
        this.disableButton(this.texts.error || 'ブランド情報の取得に失敗しました');
      }
    } finally {
      if (this.metaobjectId) {
        this.button.disabled = false;
      }
      this.button.classList.remove('is-loading');
    }
  }

  disableButton(message) {
    if (message) {
      // this.button.textContent = message;
    }
    this.button.disabled = true;
    this.button.classList.remove('is-loading');
  }

  async bootstrap() {
    if (this.customerId) {
      this.button.addEventListener('click', () => this.toggleWishlist());
    } else {
      this.button.addEventListener('click', () => this.redirectToLogin());
      // this.button.textContent = this.texts.addToBrandFavoritesText || 'お気に入りに追加';
    }

    await this.fetchBrandMetaobject();
  }

  static async init(button) {
    if (!button) {
      console.error('Brand button element is required');
      return null;
    }

    if (button.dataset.initialized === 'true') {
      return button._brandWishlistButtonInstance;
    }

    button.dataset.initialized = 'true';
    const instance = new CustomProductBrandWishlistButton(button);
    button._brandWishlistButtonInstance = instance;
    await instance.bootstrap();
    return instance;
  }

  static async initAllButtons() {
    const brandButtons = document.querySelectorAll('[data-custom-multilikes-product-brand-button]');
    const initPromises = Array.from(brandButtons).map(button =>
      CustomProductBrandWishlistButton.init(button)
    );
    await Promise.all(initPromises);
  }
}

// ページのリロード時にページ上のボタンを初期化
document.addEventListener('DOMContentLoaded', () => {
  CustomProductWishlistButton.initAllButtons();
  CustomProductBrandWishlistButton.initAllButtons();
});

// グローバル関数として公開
window.initCustomProductWishlist = function() {
  CustomProductWishlistButton.initAllButtons();
  CustomProductBrandWishlistButton.initAllButtons();
};